import React from 'react';
import "./loading.css"; // Add your custom styles here

const Loading = ({ message }) => (
  <div className="loading">
    <div className="loading-content">
      <div className="spinner"></div>
      {message && <p className="loading-message">{message}</p>}
    </div>
  </div>
);

export default Loading;
